package com.devi3east.bashbuddy.features.events.requests

import com.devi3east.bashbuddy.features.events.common.data.models.TicketType
import kotlinx.serialization.Serializable

@Serializable
data class CreateDraftTicketRequest(
    val ticketType: TicketType
)